import {HttpClient} from '@angular/common/http';
import {ChangeDetectionStrategy, Component, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Store} from '@ngrx/store';
import {filter, switchMap, tap} from 'rxjs/operators';
import {ApplicationState} from '../../../shared/store/application-state';
import {UserQuery} from '../../../shared/store/reducers/user.reducer';

@Component({
	selector: 'bas-footer-copyright',
	templateUrl: './footer-copyright.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FooterCopyrightComponent {

	releasnoteVersion = signal<string | number | null>(null);

	constructor(
		private store: Store<ApplicationState>,
		private http: HttpClient,
	) {
		this.store.select(UserQuery.getUser)
			.pipe(
				tap(user => console.log('USER:', user)),
				filter(Boolean),
				switchMap(() => this.http.get<any>('rest/version')),
				takeUntilDestroyed(),
			)
			.subscribe(debug => this.releasnoteVersion.set(debug?.releasnoteVersion ?? null));
	}
}
